<template>
    <custom-dialog :dialog-title="dialogTitle"
        :handle-dialog-close="onDialogClose" :loading="loading">
      <div class="loading-placeholder" v-show="loading">
        <loading-symbol />
      </div>
      <redirect-voucher-wizard v-show="!loading" :redirect-url="redirectUrl" />
    </custom-dialog>
</template>
<style scoped>
  .loading-placeholder {
    padding-top: 120px;
    height: 170px;
  }
</style>
<script>
import { mapState, mapActions } from 'vuex';
import CustomDialog from '@/components/CustomDialog.vue';
import LoadingSymbol from '@/components/LoadingSymbol.vue';
import i18nProvider from '../../lang/i18nProvider';
import RedirectVoucherWizard from './RedirectVoucherWizard.vue';

export default {
  name: 'redirect-voucher-dialog',
  props: {
    redirectUrl: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState({
      loading: (state) => state.voucher.loading,
      wizardStep: (state) => state.voucher.currentStep,
    }),
    i18n() {
      return i18nProvider;
    },
    dialogTitle() {
      return this.i18n.t(`discount.voucher.${this.wizardStep}.title`);
    },
  },
  methods: {
    onDialogClose() {
      this.closeRedirectDialog();
      this.removeRouteParam('redirectOffer');
    },
    ...mapActions({
      closeRedirectDialog: 'closeRedirectDialog',
      removeRouteParam: 'removeRouteParam',
    }),
  },
  components: {
    CustomDialog,
    RedirectVoucherWizard,
    LoadingSymbol,
  },
};
</script>
